import React, { useContext } from 'react';
import Button from 'react-bootstrap/Button';
import { CustomSpinner } from '@yakoffice/custom-spinner';
import RootStoreContext from '../stores/root-store-context';
import { useShowModal } from '@yakoffice/custom-modal';
import { validateEmail } from '@yakoffice/helpers';
import { usePublishSnackbarNotification } from '@yakoffice/snackbar';


export interface IProjectUserController {
    deleteUserFromProject: (projectId: string) => void,
    saveUserForProject: (projectId: string) => void
}

interface useProjectUserControllerProps {
    setUserEditStatus: (edited: boolean) => void;
    projectId: string;
    updateCallbackTrigger: (clearActiveUser?: boolean) => void;
}

export const ProjectUserController = (props: useProjectUserControllerProps) => {

    const rootStore = useContext(RootStoreContext);
    const showModal = useShowModal();
    const publishNotification = usePublishSnackbarNotification();

    const deleteUserFromProject = () => {

        const confirmDeleteUser = () => {

            showModal(
                {
                    show: true,
                    title: 'User Roles',
                    body: <CustomSpinner spinnerText={`Deleting user`} position={'relative'} />,
                    canClose: false
                }
            );

            rootStore.userStore.deleteUserForProject(props.projectId)
                .then(() => {
                    props.setUserEditStatus(false);
                    showModal({ body: '', canClose: false, title: '', show: false });
                    props.updateCallbackTrigger(true);
                })
                .catch(e => {
                    showModal({
                        show: true,
                        title: 'User Roles',
                        body: 'Error Message: ' + e.toString(),
                        canClose: true
                    });
                });
        };

        showModal(
            {
                show: true,
                title: 'User Roles',
                body: 'Are you sure you want to delete this user for this project?',
                action: <Button variant="primary" onClick={() => confirmDeleteUser()}>Yes</Button>,
                canClose: true
            }
        );

    };

    const saveUserForProject = (projectId: string) => {

        if (!validateEmail(rootStore.userStore.users[0].email)) {
            publishNotification({
                text: 'Email must be a valid email address',
                canClose: true
            });
        } else {
            rootStore.userStore.updateUserForProject(projectId)
                .then(() => {
                    props.setUserEditStatus(false);
                    props.updateCallbackTrigger();
                })
                .catch(e => {
                    showModal({
                        show: true,
                        title: `User Roles`,
                        body: 'Error Message: ' + e.toString(),
                        canClose: true
                    });
                });
        }
    };

    const controller: IProjectUserController = {
        deleteUserFromProject,
        saveUserForProject
    };

    return controller;
};
